/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Last_Bill_Detail_BaseInputs */

const es_admin_billing_last_bill_detail_base = /** @type {(inputs: Admin_Billing_Last_Bill_Detail_BaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base`)
};

const en_admin_billing_last_bill_detail_base = /** @type {(inputs: Admin_Billing_Last_Bill_Detail_BaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base`)
};

/**
* | output |
* | --- |
* | "Base" |
*
* @param {Admin_Billing_Last_Bill_Detail_BaseInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_last_bill_detail_base = /** @type {((inputs?: Admin_Billing_Last_Bill_Detail_BaseInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Last_Bill_Detail_BaseInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_last_bill_detail_base(inputs)
	return en_admin_billing_last_bill_detail_base(inputs)
});
export { admin_billing_last_bill_detail_base as "admin.billing.last_bill.detail_base" }